const PERIOD = {
	MONTHLY: 'MONTHLY',
	YEARLY: 'YEARLY',
};

export default PERIOD;
